<template>
  <happening />
</template>

<script>
import Vue from 'vue'
import happening from '@/components/HappeningModule.vue'

export default {
  name: 'HappeningModule',
  components: {
    happening
  }
}
</script>
